export const HIDE_SNACKBAR_TIMEOUT = 5000;
export const AFTER_MOUSE_LEAVE_TIMEOUT = 500;
export const BEFORE_ACTIVITY_TIMEOUT = 1000;
